<template>
	<VueCompareImage
		v-if="show && hasImages"
		:leftImage="mountImageUrl(content.beforePicture, 'before')"
		:rightImage="mountImageUrl(content.afterPicture, 'after')"
	/>
</template>

<script>
	import VueCompareImage from "vue-compare-image";
	export default {
		data() {
			return {
				show: false,
			};
		},
		props: {
			grid: {
				type: Number,
				required: true,
			},
			content: {
				required: true,
			},
		},
		methods: {
			mountImageUrl(image, position) {
				if (
					position == "before" &&
					image ==
						"https://uli-pictures.s3-sa-east-1.amazonaws.com/panel/before-after-mockup-1.jpg"
				) {
					return image;
				} else if (
					position == "after" &&
					image ==
						"https://uli-pictures.s3-sa-east-1.amazonaws.com/panel/before-after-mockup-2.jpg"
				) {
					return image;
				}

				let fitIn = `${process.env.FIT_IN_WIDTH_DEFAULT}/`;

				return `${process.env.CDN_URL}${fitIn}${image}`;
			},
		},
		computed: {
			hasImages() {
				return this.content.beforePicture && this.content.afterPicture;
			},
		},
		watch: {
			grid() {
				this.show = false;
				setTimeout(() => {
					this.show = true;
				}, 100);
			},
			content() {
				this.show = false;
				setTimeout(() => {
					this.show = true;
				}, 100);
			},
		},
		mounted() {
			setTimeout(() => {
				this.show = true;
			}, 200);
		},
		components: {
			VueCompareImage,
		},
	};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/organisms/BeforeAfterImageComponent.vue